import { FC } from 'react'
import { Divider } from 'src/components/Blocks'

export const QuestionnaireDivider: FC = () => {
    return (
        <div data-role="questionnaire-divider">
            <Divider sx={{ my: 6 }} />
        </div>
    )
}
